export default function CsharpIntro() {
  return (
    <h2>Csharp Intro</h2>
  );
}
